import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltCommentsSidebarV2FocusedThreadBackButton from './VeltCommentsSidebarV2FocusedThreadBackButton/VeltCommentsSidebarV2FocusedThreadBackButton';
import VeltCommentsSidebarV2FocusedThreadDialogContainer from './VeltCommentsSidebarV2FocusedThreadDialogContainer/VeltCommentsSidebarV2FocusedThreadDialogContainer';
var VeltCommentsSidebarV2FocusedThread = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-focused-thread-v2-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarV2FocusedThread.BackButton = VeltCommentsSidebarV2FocusedThreadBackButton;
VeltCommentsSidebarV2FocusedThread.DialogContainer = VeltCommentsSidebarV2FocusedThreadDialogContainer;
export default VeltCommentsSidebarV2FocusedThread;
